import useFetch from './useFetch';
import TwilioService from '../services/twilio-service';
import usePush from './usePush';
import useEvent from './useEvent';
import { BannerTypes, useBanner } from '../components/BannerControl';
import { CallStages } from '../components/VoiceCallingBanners';
import useShortCode from './useShortCode';
import { useBannerContext } from '../components/BannerControl/BannerRenderer';

function useDialNumber() {
  const { setCallId } = useBannerContext();
  const showBanner = useBanner();
  const shortCode = useShortCode();

  useEvent('acceptCall', args => {
    showBanner(BannerTypes.voiceCall, {
      callStage: CallStages.in_progress,
      ...args,
    });

    setCallId(args.callId);
  });

  const { data: token } = useFetch(TwilioService.getToken, { shortCode }, { suspense: false });
  const { execute: dialNumber } = usePush(TwilioService.dialNumber);
  return async (phoneNumber, opts) => dialNumber(token, phoneNumber, opts);
}

export default useDialNumber;
